import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, GameData, REGIONS, SHAPES } from '../gameData';
import SoundAssetKeys from "../SoundAssetKeys";

export default class LifeguardStandArea extends RegionArea
{
    /**
     * Create the lifeguard stand area.
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[REGIONS.BEACH].LIFEGUARD_STAND);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.rectangle0.setAlpha(0);
        this.rectangle1.setAlpha(0);
        this.rectangle2.setAlpha(0);
        this.rectangle3.setAlpha(0);
        this.rectangle4.setAlpha(0);
        this.rectangle5.setAlpha(0);

        this.pyramid.setAlpha(0);

        this.rectangularPrism0.setAlpha(0);
        this.rectangularPrism1.setAlpha(0);
        this.rectangularPrism2.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.rectangle0.disableInteractive();
        this.rectangle1.disableInteractive();
        this.rectangle2.disableInteractive();
        this.rectangle3.disableInteractive();
        this.rectangle4.disableInteractive();
        this.rectangle5.disableInteractive();

        this.pyramid.disableInteractive();

        this.rectangularPrism0.disableInteractive();
        this.rectangularPrism1.disableInteractive();
        this.rectangularPrism2.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.rectangle0.setAlpha(0.000001);
        this.rectangle1.setAlpha(0.000001);
        this.rectangle2.setAlpha(0.000001);
        this.rectangle3.setAlpha(0.000001);
        this.rectangle4.setAlpha(0.000001);
        this.rectangle5.setAlpha(0.000001);
        this.pyramid.setAlpha(0.000001);
        this.rectangularPrism0.setAlpha(0.000001);
        this.rectangularPrism1.setAlpha(0.000001);
        this.rectangularPrism2.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        for (let i = 0; i < 6; i++)
        {
            this["rectangle" + i] = ABCya.Images.addImage(0, 0, UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Flag, this.parentRegion);
            this["rectangle" + i].on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => 
            {
                this._onOverlayPointerDown(this["rectangle" + i], SHAPES.RECTANGLE);
            });
        }

        this.rectangle0.setPosition(447, 212).setFrame(UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Flag).setInteractive();
        this.rectangle1.setPosition(448, 101).setFrame(UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Flag).setInteractive();

        let stepHitArea = new Phaser.Geom.Polygon(
            [
                { x: 0, y: 65 },
                { x: 109, y: 0 },
                { x: 148, y: 24 },
                { x: 39, y: 89 },
            ]);
        this.rectangle2.setPosition(862, 614).setFrame(UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Step).setInteractive(stepHitArea, Phaser.Geom.Polygon.Contains);
        this.rectangle3.setPosition(898, 670).setFrame(UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Step).setInteractive(stepHitArea, Phaser.Geom.Polygon.Contains);

        let window1HitArea = new Phaser.Geom.Polygon(
            [
                { x: 2, y: 120 },
                { x: 2, y: 29 },
                { x: 55, y: 0 },
                { x: 55, y: 92 },
            ]);
        this.rectangle4.setPosition(850, 371).setFrame(UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Wndw1).setInteractive(window1HitArea, Phaser.Geom.Polygon.Contains);

        let window2HitArea = new Phaser.Geom.Polygon(
            [
                { x: 0, y: 91 },
                { x: 0, y: 0 },
                { x: 118, y: 67 },
                { x: 118, y: 156 },
            ]);
        this.rectangle5.setPosition(666, 379).setFrame(UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Wndw2).setInteractive(window2HitArea, Phaser.Geom.Polygon.Contains);

        let pyramidHitArea = new Phaser.Geom.Polygon(
            [
                { x: 0, y: 122 },
                { x: 208, y: 0 },
                { x: 420, y: 122 },
                { x: 208, y: 246 },
            ]);
        this.pyramid = ABCya.Images.addImage(739, 223, UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Roof, this.parentRegion).setInteractive(pyramidHitArea, Phaser.Geom.Polygon.Contains);
        this.pyramid.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.pyramid, SHAPES.PYRAMID);
        });

        let legStandHitArea = new Phaser.Geom.Polygon(
            [
                { x: 0, y: 112 },
                { x: 21, y: 124 },
                { x: 42, y: 112 },
                { x: 42, y: 13 },
                { x: 21, y: 0 },
                { x: 0, y: 13 },
            ]);
        for (let i = 0; i < 3; i++)
        {
            this["rectangularPrism" + i] = ABCya.Images.addImage(0, 0, UIAssetKeys._05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_RP, this.parentRegion).setInteractive(legStandHitArea, Phaser.Geom.Polygon.Contains);
            this["rectangularPrism" + i].on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => 
            {
                this._onOverlayPointerDown(this["rectangularPrism" + i], SHAPES.RECTANGULAR_PRISM);
            });
        }
        this.rectangularPrism0.setPosition(513, 497);
        this.rectangularPrism1.setPosition(739, 629);
        this.rectangularPrism2.setPosition(967, 497);

        this.shapeOverlays[SHAPES.RECTANGLE] = [this.rectangle0, this.rectangle1, this.rectangle2, this.rectangle3, this.rectangle4, this.rectangle5];
        this.shapeOverlays[SHAPES.PYRAMID] = [this.pyramid];
        this.shapeOverlays[SHAPES.RECTANGULAR_PRISM] = [this.rectangularPrism0, this.rectangularPrism1, this.rectangularPrism2];

        this._createAreaInformation(0x5f5fd6, 0x5f5fd6);
    }

    /**
     * Callback function when an overlay is clicked on. Extends the original function and hides the area instructions.
     * @param {Phaser.GameObjects.Image} overlay the shape overlay that was clicked on
     * @param {string} shape the SHAPE enum value that the overlay belongs to
     */
    _onOverlayPointerDown(overlay, shape)
    {
        if (this.parentRegion.areaInstructionsPopup.state == 1)
        {
            this.parentRegion.areaInstructionsPopup.state = 2;
            ABCya.Tweens.addTween(this.parentRegion.areaInstructionsPopup, 350, { y: this.parentRegion.areaInstructionsPopup.offScreenPosition.y }, Phaser.Math.Easing.Back.In);
        }

        super._onOverlayPointerDown(overlay, shape);
    }

    /**
     * Creates the shape information for the area. These are the buttons that can be clicked to find the shapes.
     * Extends the original function and adds an additional listener to show the 2nd set of instructions when a shape name is clicked.
     * @param {number} numberFontColor the number font color
     * @param {number} textFontColor the text font color
     */
    _createAreaInformation(numberFontColor, textFontColor)
    {
        super._createAreaInformation(numberFontColor, textFontColor);

        for (let shape in GameData.region_data[this.region][this.area])
        {
            let containerShapeObj = this.areaInformation[shape];
            containerShapeObj.shapeButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => 
            {
                if (this.parentRegion.areaInstructionsPopup.state == 0)
                {
                    this.parentRegion.areaInstructionsPopup.state = 1;
                    if (this.parentRegion.areaInstructionsPopup.firstInstructionsAudio.isPlaying)
                    {
                        this.parentRegion.areaInstructionsPopup.firstInstructionsAudio.stop();
                    }
                    ABCya.Audio.playOneShot(SoundAssetKeys._locate_that_shape, this.parentRegion.scene, 1, false, 0.25);
                    ABCya.Tweens.addTween(this.parentRegion.areaInstructionsPopup.firstInstructions, 350, { alpha: 0 }, Phaser.Math.Easing.Quadratic.In);
                    ABCya.Tweens.addTween(this.parentRegion.areaInstructionsPopup.secondInstructions, 350, { alpha: 1, delay: 300 }, Phaser.Math.Easing.Quadratic.Out);
                }
            });
        }
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.beachball, this.parentRegion.sandcastle, this.parentRegion.seagullContainer
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.lifeguardContainer, duration: 1000, props: { scale: 1.8, x: -40, y: -45 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.rectangle0.disableInteractive();
        this.rectangle1.disableInteractive();
        this.rectangle2.disableInteractive();
        this.rectangle3.disableInteractive();
        this.rectangle4.disableInteractive();
        this.rectangle5.disableInteractive();

        this.pyramid.disableInteractive();

        this.rectangularPrism0.disableInteractive();
        this.rectangularPrism1.disableInteractive();
        this.rectangularPrism2.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.lifeguardContainer, duration: 1000, props: { scale: 1, x: this.parentRegion.lifeguardContainer.onScreenPosition.x, y: this.parentRegion.lifeguardContainer.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.sandcastle, this.parentRegion.beachball, this.parentRegion.seagullContainer], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}